export const LanyonRoomTypes = [
    {id: '0', value:''},
    {id:'1',	value: 'Apartment'},
    {id:'2',	value: 'Business Plan'},
    {id:'3',	value: 'Business Class'},
    {id:'4',	value: 'Classic'},
    {id:'5',	value: 'Club'},
    {id:'6',	value: 'Comfort'},
    {id:'7',	value: 'Concierge'},
    {id:'8',	value: 'Deluxe'},
    {id:'9',	value: 'Deluxe Suite'},
    {id:'10',	value: 'Economy'},
    {id:'11',	value: 'Efficiency'},
    {id:'12',	value: 'Executive'},
    {id:'13',	value: 'Junior Suite'},
    {id:'14',	value: 'Luxury'},
    {id:'15',	value: 'Premier'},
    {id:'16',	value: 'Physically Challenged'},
    {id:'17',	value: 'Run Of House'},
    {id:'18',	value: 'Standard'},
    {id:'19',	value: 'Studio'},
    {id:'20',	value: 'Suite'},
    {id:'21',	value: 'Superior'},
    {id:'22',	value: 'Villa'},
    {id:'23',	value: 'One Bedroom'},
    {id:'24',	value: 'Two Bedrooms'},
    {id:'25',	value: 'Three Bedrooms'},
]

    